import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                openTable: 'openTable',
                closeTable: 'closeTable'
            }
        }
    }

    openTable() {
        this.call('stop', 'Scroll');
        this.el.querySelector('.page-onboarding-table').classList.add('-visible');
    }

    closeTable() {
        this.call('start', 'Scroll');
        this.el.querySelector('.page-onboarding-table').classList.remove('-visible');
    }
}
